export default __webpack_public_path__ + "static/media/figuremap39.6ad16354.png";